export const localRecordingDescription =
  'Means you will record what you see on your local computer. If your browser crashes or you ' +
  'close the browser without waiting for the recording to be uploaded you may lose the content.'

export const cloudRecordingDescription =
  'Means recording is done in the cloud. It may not be exactly what you see. If your internet connection is not ' +
  'good, cloud recording is better quality. It is 99% reliable.'
